import request from '@/utils/bbs_request'

// 获取机构App
export function getAgencyAppList(params) {
  return request({
    url: '/index/index/getAgencyAppList',
    method: 'get',
    params
  })
}
  